###
Copyright (c) 2012 Gridspy Ltd
All Rights Reserved
###

# Library Functions
# ---------------------

if not gs?
  window.gs = {}

ko.bindingHandlers.jqButton = {
    init: (element) ->
       $(element).button() # Turns the element into a jQuery UI button
    
    update: (element, valueAccessor) ->
        currentValue = valueAccessor()
        $(element).button "option", "disabled", currentValue.enable == false
};


# Knockout data model.
# --------------------

class Sensor 
   constructor: (@pk, @name, @building, @units, @rounding, @colour) ->


class Input
  constructor: (@pk, @pos, @gs_desc, units, name, desc) ->
    @name = ko.observable name
    @desc = ko.observable desc
    @units = ko.observable units
    @sens_pk = null
    
    @dirty = new gs.ManualDirtyFlag(@name, @desc)
    @dirty.addCallback -> gs.installer.queue_save()

    @was_saving = false
    
    @curr_value = new ko.observable '-'
    
    @is_configured = ko.computed => @pk or @name()
    @should_save= ko.computed => @is_configured() and @dirty.isDirty()

    @dirty.reset()

  #Todo: Live Value, presentation based on unit type, input name
  apply_config: (cfg) ->
    @dirty.setModifying()
    {pk: @pk, sens_pk: @sens_pk} = cfg
    @name cfg.name
    @desc cfg.desc
    @dirty.reset()

  get_config: ->
    cfg = {}
    cfg.pk = @pk
    cfg.name = @name()
    cfg.desc = @desc()
    cfg.units = @units()
    
    return cfg
  
  set_saving: ->
    @dirty.reset()
    @was_saving = true
  
  save_done: ->
    return unless @was_saving
    @was_saving = false
    
  apply_state: (in_state) ->
    if @units() of in_state
      @curr_value in_state[@units()]
    
    # Note here - Dirty flag will now be set if the data was modified after the save began, 
    #              which will trigger a helpful subsequent save 

class AcInput extends Input
  constructor: (pk, pos, gs_desc, units, name, desc, ct, phase, ct_rev) ->
    super pk, pos, gs_desc, units, name, desc, ct
    
    @ct   = ko.observable ct
    @phase = ko.observable phase   # 1, 2 or 3 where 1 is same phase as AC adaptor
    @ct_rev = ko.observable ct_rev # Is the CT reversed?
    
    @dirty.addObservables @ct, @phase, @ct_rev
    
    @curr_watts = ko.observable '-'
    @curr_amps = ko.observable '-'
    @curr_angle = ko.observable '-'
    @curr_PF = ko.observable '-'

    @dirty.reset() 

  apply_config: (cfg) ->
    super cfg
    
    @dirty.setModifying()

    @ct gs.installer.get_ct cfg.ct
    [phase, ct_rev] = gs.installer.get_mode cfg.mode
    @phase phase
    @ct_rev ct_rev

    @dirty.reset() 
    
  get_config:  ->
    cfg = super()
    
    cfg.ct = @ct()?.pk
    cfg.phase = @phase()?.name 
    cfg.phase += 'R' if @ct_rev()
    
    return cfg
   
  apply_state: (in_state) ->
    super in_state
    @curr_watts in_state['watt']
    @curr_amps in_state['amp']
    if in_state['angle'] > 320.0
      @curr_angle Math.round(in_state['angle'] - 360.0)
    else if in_state['angle'] < -40.0
      @curr_angle Math.round(in_state['angle'] + 360.0)
    else 
      @curr_angle Math.round(in_state['angle'])
    @curr_PF in_state['PF']

class DCInput extends Input
  # Represents a DC input to a DC GridNode.
  # Should show incoming voltage in V from 0-10V
  # Also show corresponding measured
  constructor: (pk, pos, gs_desc, units, name, desc, multiple) ->
    super pk, pos, gs_desc, units, name, desc, null

    @multiple = ko.observable multiple # A multiplier on each pulse

    @dirty.addObservables @multiple, @units

    @curr_reading = ko.observable 0
    @curr_volts = ko.computed =>  @curr_reading() / 1000 # 100 counts per volt
    @curr_value = ko.computed => (@curr_reading() / 1000) * @multiple()

    @dirty.reset()

    @dc_desc = "DC " + gs_desc.split(" ")[1]

  apply_config: (cfg) ->
    super cfg

    @dirty.setModifying()

    @multiple cfg.multiple * 1000
    @units cfg.units

    @dirty.reset()

  get_config:  ->
    cfg = super()

    cfg.multiple = @multiple() / 1000
    cfg.units = @units()

    return cfg

  apply_state: (in_state) ->
    @curr_reading in_state['watt']

class CountInput extends Input
  constructor: (pk, pos, gs_desc, units, name, desc, multiple) ->
    super pk, pos, gs_desc, units, name, desc, null

    @multiple = ko.observable multiple # A multiplier on each pulse

    @dirty.addObservables @multiple, @units

    @curr_counts = ko.observable '-'
    @curr_units = ko.computed => @curr_counts() * @multiple()

    @dirty.reset()

  apply_config: (cfg) ->
    super cfg
    @dirty.setModifying()

    @multiple cfg.multiple
    @units cfg.units

    @dirty.reset()

  get_config:  ->
    cfg = super()

    cfg.multiple = @multiple()
    cfg.units = @units()

    return cfg

  apply_state: (in_state) ->
    super in_state
    @curr_counts in_state['counts']


# Watts Input Class
#  - CT Settings, Current Value, Phase Angle, processing maths

# Node Class
#  - Inputs, Watt Inputs

class Node
  constructor: (@addr, rssi, rssi_db, radio_state) ->
    @rssi = ko.observable rssi
    @rssi_db = ko.observable rssi_db
    @node_details = ko.observable null
    @no_config = ko.observable true

    @dc_node = ko.observable false

    @radio_state = ko.observable radio_state
    node_base = (@addr - 1) * 100
    ac_in = (new AcInput(null, 1080 + node_base + x - 1, "AC #{x}", 'watt', null, null, null, 1, false) for x in [1..6])
    @ac_inputs = ko.observableArray ac_in

    #dc_in = (new DCInput(null, 1080 + node_base + x - 1, "AC #{x}", 'amp', null, null, 1) for x in [1..6])
    @dc_inputs = ko.observableArray []

    temp_in = [new Input(null, 1014 + node_base, "Int Temp", 'deg C', null, null),
               new Input(null, 1015 + node_base, "Ext Temp", 'deg C', null, null) ]
    @temp_inputs = ko.observableArray temp_in

    count_in = (new CountInput(null, 1016 + node_base + x - 1, "Ctr #{x}", 'count', null, null, null) for x in [1..2])
    @count_inputs = ko.observableArray count_in

    @all_inputs = ko.computed => @ac_inputs().concat(@dc_inputs(), @temp_inputs(), @count_inputs())

    # return an object where there is one key set to true. The key's name matches the class
    #  we want to set for this node.
    @radio_state_css =  ko.computed =>
      out = {online: false, offline: false, unseen:false}
      out[@radio_state()] = true
      if @radio_state() == "unseen"
        out["offline"] = true # Also set offline.
      else if @radio_state() != "offline"
        @no_config false

      out['unused'] = @no_config()
      #out['offline'] = false # Temp: Force remove offline for testing / until we have a force show option.
      return out
      
    @rssi_pc = ko.computed => "#{@rssi()}%"
    @kwh_values = ko.observable null
    @kwh_lines = ko.computed => @calc_kwh_lines()
    @show_kwh = ko.observable false
    @kwh_last_update = ko.computed =>
      kwh = @kwh_values()
      return null unless kwh?

      return new Date(kwh['time'])


  calc_kwh_lines: () ->
    for idx in [0..5]
      input: @ac_inputs()[idx]
      kwh: @kwh_values()?.kwh_derived[idx].toFixed(6)
      raw_kwh: @kwh_values()?.kwh[idx].toFixed(6)
      raw_kwhi: @kwh_values()?.kwhI[idx].toFixed(6)

  apply_state: (node_state) ->
    @radio_state node_state.radio_state
    
    if node_state.radio?
      @rssi node_state.radio.rssi_pc
      @rssi_db node_state.radio.rssi_db

    if node_state.data?
      for input in @all_inputs()
        in_state = a_state for a_state in node_state.data when a_state[0] == input.gs_desc
        
        continue unless in_state?  
        
        input.apply_state in_state[1]

    if node_state.kwh?
      @kwh_values node_state.kwh
    
    
class Hub
  constructor: () ->
    @id = ko.observable null
    
    @ip = ko.observable null
    @online = ko.observable null
    
    @ac_inputs = ko.observableArray []
    @temp_inputs = ko.observableArray []
    @count_inputs = []
    @dc_inputs = []

    @all_inputs = ko.computed => @ac_inputs().concat(@temp_inputs())

    @connected_time = ko.observable ""
    @bytes_sent = ko.observable null
    @bytes_rec = ko.observable null
    @pkts_sent = ko.observable null
    @pkts_rec = ko.observable null
    @hub_table = ko.observable null

    # Total bytes span multiple connections
    @total_sent = ko.observable null
    @total_rec = ko.observable null

    @online_state_css =  ko.computed =>
      out = {online: false, offline: false, unseen:false}
      out[@online()] = true
      return out
      
    @reset()
    
  reset: ->

    @ip null
    @online null
    
    ac_in = (new AcInput(null, 10 + ((x-1) * 2), "AC #{x}", 'watt', null, null, 1, false) for x in [1..3])
    @ac_inputs ac_in  
    temp_in = [ new Input(null, 16, "Ext Temp", 'deg C', null, null) ]
    @temp_inputs temp_in

    @connected_time ""
    @bytes_sent  null
    @bytes_rec  null
    @pkts_sent null
    @pkts_rec  null
    @hub_table null
    
    # Total bytes span multiple connections
    @total_sent null
    @total_rec null

  apply_state: (state) ->
    @ip state.conn_ip
    @online state.conn_state
    
    @connected_time state.conn_desc
    
    # NB:Total bytes span multiple connections
    if state.comm_stats
      stats = state.comm_stats
      @total_sent stats.sent
      @bytes_sent stats.sent_conn
      @pkts_sent stats.sent_pkts
      
      @total_rec stats.rec
      @bytes_rec stats.rec_conn
      @pkts_rec stats.rec_pkts
    
    if state.hub_data?
      for input in @all_inputs()
        in_state = a_state for a_state in state.hub_data when a_state[0] == input.gs_desc
        
        continue unless in_state?  
        
        input.apply_state in_state[1]

    if state.hub_table?
      @hub_table state.hub_table

class MenuItem_Hub
  constructor: (@id, @sn, @name, @building, @conn) ->
    @is_selected = ko.computed =>
      return @id == gs.installer.hub.id() 

    @desc = ko.computed =>
      if @name and @name != ""
        @name
      if @building and @building != ""
        @building
      else
        @id
    
    @expand = ko.observable false
    @sensors = ko.mapping.fromJS []
    @sensors_unloaded = true
    
    @sensors_bydev = ko.computed =>
      devices = {}
      for own idx, sensor of @sensors()
        category = sensor['pos_info']?['dev']()
        unless category
          category = "Other"
        
        unless category of devices
          devices[category] = 
            name:category
            sensors:[sensor]
        else
          devices[category].sensors.push(sensor)
          
      sortable = (device for own idx, device of devices)
      sortable.sort (a,b)->
        a.name.localeCompare b.name
      for own idx, device of sortable
        device.sensors.sort (a,b)->
          a['pos_info']?['in']?()?.localeCompare b['pos_info']?['in']?()
      
      return sortable

    @conn_online = ko.computed =>
      @conn?.search("Until") == -1
    @conn_time = ko.computed =>
      return null unless @conn?
      Date.parseExact(@conn.replace("Until ", ""), ["dd/M HH:mm"])
    @conn_last_30 = ko.computed =>
      return false unless @conn_online()
      return @conn_time() > new Date().add(-30).minutes()

  update_subsensors: ->
    @sensors_unloaded = false
    url = "/d/hub/#{@id}/sensors.json"
    $.ajax
      url: url
      dataType: 'json' 
      success: (data, textStatus, jqXHR) =>
        console?.log "Got #{@id} hub sensor list:", textStatus, data
        ko.mapping.fromJS data.sensors, @sensors        
                
      error: (jqXHR, textStatus, errorThrown) => 
        console?.log "Error #{@id} hub sensor list:", textStatus, errorThrown

  toggle_expand: =>
    @expand !@expand()
    if @sensors_unloaded
      @update_subsensors()  
    
  install_hub: ->
    gs.installer.install_hub(@id)


class Building
  constructor: () ->
    @tag = ko.observable ''
    @name = ko.observable ''
    @desc = ko.observable ''

    @tag.subscribe (newValue) =>
      # Called when tag is changed. Force it to be valid
      strict = newValue.toLowerCase()
      strict = strict.replace(/\ /g, "_")
      strict = strict.replace(/[^a-z0-9_]/, "")

      if strict != newValue
        #force the tag to the stricter version.
        @tag strict


    @example_url = ko.computed => "https://gridspy.com/db/##{@tag()}"
    @example_old_url = ko.computed => "https://gridspy.com/your/#{@tag()}"

  apply_config: (cfg) ->
    @tag cfg.tag
    @name cfg.name
    @desc cfg.desc
    
  get_config: ->
    cfg = {}
    cfg.tag = @tag()
    cfg.name = @name()
    cfg.desc = @desc()
    
    return cfg 
     

class InstallViewModel
  constructor: () ->
    @sensors = ko.observableArray []

    @nodes = ko.observableArray []
    
    @hub = new Hub()
    @building = new Building()
    
    @saving_msg = ko.observable ""
    @saving_response = ko.observable ""
    @desired_id = null # Used to store the desired hub id between request and when we can actually do it.
    
    @not_configured = ko.observable true    
    
    @advanced = ko.observable true
    @advanced_toggle = => @advanced !@advanced()
    
    @server_msg = ko.observable null
    @radio_summary = ko.observable {}

    @ct_options = [ 
      {pk:1, name: '15A', multiplier: 1}
      {pk:2, name: '60A', multiplier: 2.88}
      {pk:4, name: '200A', multiplier: 15.6}
      {pk:3, name: '400A', multiplier: 31.2}
      {pk:5, name: '600A', multiplier: 46.8}
      {pk:7, name: '1,000A', multiplier: 78.0}

      {pk:9, name: '1,000A Rope'}
      {pk:8, name: '3,000A Rope'}
      {pk:10, name: '5,000A Rope'}
    ]
    
    @ct_mode = [
        #{name: 'Auto', desc: 'Auto', phase_num: 0},
        {name: 'Phase1', desc: 'Phase 1 (No offset)', phase_num: 1},
        {name: 'Phase2', desc: 'Phase 2 (120 degree offset)', phase_num: 2},
        {name: 'Phase3', desc: 'Phase 3 (240 degree offset)', phase_num: 3},
    ]
    
    @selected_hub_overview = ko.observable null
    @your_hubs = ko.observableArray []
    @do_save = () => @do_actual_save()
    
  dirtyItems: ->
    list = []
    dirty_list = (input_list) -> 
      an_item.name() for an_item in input_list when an_item.dirty.isDirty() and an_item.is_configured()
    
    list += dirty_list @hub.all_inputs()
    list += dirty_list node.all_inputs() for node in @nodes()
    return list
  
  isDirty: -> 
    return @dirtyItems().length > 0
    
  get_ct: (pk) ->
    for ct in @ct_options
      return ct if ct.pk == pk
    
    return null
 
  get_mode: (name) ->
    return [null, false] unless name?
    
    ct_rev = name[name.length-1] == 'R'
    if ct_rev
      # Cut the R off the end
      name = name[0..name.length-2]
      
    for mode in @ct_mode
      return [mode, ct_rev] if mode.name == name
    
    return [null, false]
    
  update_hubs: (hub_list) ->
    hubs = for hub in hub_list
      new MenuItem_Hub(hub['mac_addr'], hub['sn'], hub['name'], hub['building__tag'], hub['conn'])
    
    hubs.sort (a,b)->
      (a.building+a.name).localeCompare (b.building+b.name)
      
    @your_hubs hubs

    if @hub.id()? and @hub.id() != ""
        @install_hub @hub.id()
    else if @desired_id?
        @install_hub @desired_id

        
  cfg_fail: () ->
    # Called by live
  
  auth_fail: ()->
    # Called by live
    @update_hubs []
           
    
  goto_hub_list: =>
    #@install_hub(null)
    gs.router.navigate("#setup")
    
  install_hub: (hub_id) ->
    # @do_save() if @isDirty() Could this cause race conditions on server?

    @nodes []
    @not_configured  true
    @desired_id = null

    if hub_id? and hub_id != ""
      hub_found = false
      for hub in @your_hubs()
        if hub.id == hub_id
          hub_found = true
          @selected_hub_overview hub
          break

      if not hub_found
        @hub.id null
        @selected_hub_overview null
        #@goto_hub_list()
        @desired_id = hub_id
        return
      else
        @hub.reset()
        @hub.id hub_id
        gs.live_data.set_hub(hub_id)

      gs.show_loading("inst_get_cfg")
    else
      @hub.id null

  run_with_inputs: (func) ->
    # Runs the passed function over all inputs

    func input for input in @hub.all_inputs()
    (func input for input in node.all_inputs()) for node in @nodes()
    return false
  
  # Building Config
  apply_input_config: (config) ->
    gs.done_loading("inst_get_cfg")
    first_run = false
    if @not_configured()
      node_list = (new Node(x, 0, 0, "offline") for x in [1..6])
      @nodes node_list
      @not_configured  false
      first_run = true

    @run_with_inputs (input) ->
      cfg = config[input.pos]
      # console?.log input.pos, cfg
      return unless cfg? 
      
      unless first_run
        # Don't apply a new config to configured, dirty inputs.
        return if input.is_configured() and input.dirty.isDirty()
      input.apply_config(cfg)
      
    for sn, node_details of config.nodes
      node = @nodes()[node_details.rf_addr]
      continue unless node?

      node.node_details node_details
      node.no_config false

    @building.apply_config(config.building) if config.building?
      
  apply_state: (state) ->
    # console?.log "Install state recieved", state
    @hub.apply_state state
    for node in @nodes()
      node_state = state.nodes?[node.addr-1]
      continue unless node_state?
      node.apply_state node_state

  apply_radio: (summary) ->
    @radio_summary summary

  build_input_config: (set_saving = false) ->
    result = {}
    @run_with_inputs (input) ->
      return unless input.is_configured() and input.dirty.isDirty()
      
      result[input.pos] = input.get_config()
      
      # Clear the dirty flag in the input and set a flag to say a save is underway.
      input.set_saving() if set_saving
    
    result['building'] = @building.get_config()
    
    return result
    
  do_actual_save: ->
    @saving_msg "Saving: #{ko.toJSON @dirtyItems()}"
    cfg = @build_input_config true
    @saving_response "Waiting for server..."
    gs.live_data.save_cfg(cfg)
    gs.show_loading("inst_save")

  save_done: (save_result) ->
    gs.done_loading("inst_save")
    @run_with_inputs (input) ->
      return unless input.is_saving
      
      input.was_saved()
    
    @saving_response ko.toJSON save_result
    
  queue_save: ->
    return if @queued_save_timer?
    
    @queued_save_timer = window.setTimeout( => 
      @queued_save_timer = null
      return unless @isDirty()
      @do_save()
    , 5000)   

  edit_sensor_tree: (tag) ->
    building = gs.bindings.building_list.by_tag tag
    unless building?
      #console?.log "Building #{tag} could not be found in our list to edit hierarachy. Are you sure you can access it?"
      return
      
    console?.log building.hierarachy
    @tree.load building.hierarachy
    return @tree
    
    

# From http://www.knockmeout.net/2011/05/dragging-dropping-and-sorting-with.html

#connect items with observableArrays
ko.bindingHandlers.sortableList = init: (element, valueAccessor, allBindingsAccessor, context) ->
  $(element).data "sortList", valueAccessor() #attach meta-data
  $(element).sortable
    update: (event, ui) ->
      item = ui.item.data("sortItem")
      if item
        
        #identify parents
        originalParent = ui.item.data("parentList")
        newParent = ui.item.parent().data("sortList")
        
        #figure out its new position
        position = ko.utils.arrayIndexOf(ui.item.parent().children(), ui.item[0])
        if position >= 0
          originalParent.remove item
          newParent.splice position, 0, item
        ui.item.remove()

    connectWith: ".container"



#attach meta-data
ko.bindingHandlers.sortableItem = init: (element, valueAccessor) ->
  options = valueAccessor()
  $(element).data "sortItem", options.item
  $(element).data "parentList", options.parentList


#control visibility, give element focus, and select the contents (in order)
ko.bindingHandlers.visibleAndSelect = update: (element, valueAccessor) ->
  ko.bindingHandlers.visible.update element, valueAccessor
  if valueAccessor()
    setTimeout (->
      $(element).focus().select()
    ), 0 #new tasks are not in DOM yet

window.gs.installer = new InstallViewModel()
